import { Action } from '@ngrx/store';
import { ICertificateData, CertStatus } from '@app/certificates/manage/manage';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { IMobileDevice } from './../devices/devices';

export const certKey = 'CERTIFICATES';

export enum ManageCertificateActionTypes {
    INITIALIZE = '[Cert] Initialize',
    GET = '[Cert] Get',
    RESTORE_REQEST = '[Cert] restore',
    RESTORE_SUCCESS = '[Cert] Restore success',
    RESTORE_FAIL = '[Cert] Restore fail',
    HOLD = '[Cert] Hold',
    HOLD_SUCCESS = '[Cert] Hold success',
    ADD_DEVICE = '[Cert] Add device',
    ADD_DEVICE_SUCCESS = '[Cert] Add device success',
    ERROR = '[Cert] Error',
    CLEAR_CERTIFICATES = '[Cert] Clear certificates',
    SUCCESS_CHANGE_CERTIFICATES = '[Cert] Certificate success changing state',
    UPDATE_DEVICES = '[Cert] update devices'
}

export class ActionCertificatesInitialize implements Action {
  readonly type = ManageCertificateActionTypes.INITIALIZE;
  constructor(public payload: { certificates: ICertificateData[] }) { }
}

export class ActionCertificatesGet implements Action {
  readonly type = ManageCertificateActionTypes.GET;
  constructor() { }
}

export class ActionCertificatesRestoreRequest implements Action {
  readonly type = ManageCertificateActionTypes.RESTORE_REQEST;
  constructor(public payload: { certReqId: ICertificateData['certReqId'] }) { }
}

export class ActionCertificatesRestoreSuccess implements Action {
  readonly type = ManageCertificateActionTypes.RESTORE_SUCCESS;
  constructor(public payload: { certificates: ICertificateData[] }) { }
}

export class ActionCertificatesHold implements Action {
  readonly type = ManageCertificateActionTypes.HOLD;
  constructor(public payload?: { certReqId: ICertificateData['certReqId'] }) { }
}

export class ActionCertificatesSuccessChangeState implements Action {
  readonly type = ManageCertificateActionTypes.SUCCESS_CHANGE_CERTIFICATES;
  constructor(public payloads?: Array<{ certReqId: ICertificateData['certReqId'], certificateStatus: CertStatus }>) { }
}

export class ActionCertificatesUpdateDevicesState implements Action {
  readonly type = ManageCertificateActionTypes.UPDATE_DEVICES;
  constructor(public payload?: { certReqId: ICertificateData['certReqId'], newDevices: IMobileDevice[] }) { }
}

export class ActionCertificatesHoldSuccess implements Action {
  readonly type = ManageCertificateActionTypes.HOLD_SUCCESS;
  constructor(public payload?: { certificates: ICertificateData[] }) { }
}

export class ActionError implements Action {
  readonly type = ManageCertificateActionTypes.ERROR;
  constructor(public payload: { response?: ISpringResponseBody }) { }
}

export class ActionCertificatesClearCertificates implements Action {
  readonly type = ManageCertificateActionTypes.CLEAR_CERTIFICATES;
}

export type ManageCertificateActions =
    ActionCertificatesGet |
    ActionCertificatesInitialize |
    ActionCertificatesRestoreRequest |
    ActionCertificatesRestoreSuccess |
    ActionCertificatesHold |
    ActionCertificatesHoldSuccess |
    ActionCertificatesClearCertificates |
    ActionCertificatesSuccessChangeState |
    ActionCertificatesUpdateDevicesState |
    ActionError;

export const selectorCertificate = state => state.certificates as ICertificateData[];

export function manageCertificateReducer(
    state: ICertificateData[],
    action: ManageCertificateActions
): ICertificateData[] {
    switch (action.type) {
        case ManageCertificateActionTypes.RESTORE_REQEST:
          return updateStatus(state, action.payload.certReqId, CertStatus.PENDING_RESTORE);
        case ManageCertificateActionTypes.HOLD:
          return updateStatus(state, action.payload.certReqId, CertStatus.PENDING_HOLD);
        case ManageCertificateActionTypes.UPDATE_DEVICES:
          return updateDevices(state, action.payload);
        case ManageCertificateActionTypes.SUCCESS_CHANGE_CERTIFICATES:
          return updateSuccessStatuses(state, action.payloads);

        case ManageCertificateActionTypes.INITIALIZE:
        case ManageCertificateActionTypes.RESTORE_SUCCESS:
        case ManageCertificateActionTypes.HOLD_SUCCESS:
            return action.payload.certificates;
        case ManageCertificateActionTypes.CLEAR_CERTIFICATES:
            return [];

    default:
      return state;
  }
}

function updateSuccessStatuses(
    certificates: ICertificateData[],
    payloads: Array<{
        certReqId: ICertificateData['certReqId'],
        certificateStatus: CertStatus
      }>): ICertificateData[] {
  const newCertificates = JSON.parse(JSON.stringify(certificates));
  let certsUpdated = false;
  payloads.forEach(payload => {
     if (payload.certificateStatus !== CertStatus.PENDING_HOLD &&
         payload.certificateStatus !== CertStatus.PENDING_RESTORE) {
        newCertificates.map((v: ICertificateData) => {
            if (v.certReqId === payload.certReqId) {
              certsUpdated = true;
              v.status = payload.certificateStatus;
            }
        });
      }
    });

  // We need this check because JSON.parse(JSON.stringify(certificates)) creates separate copy and this means
  // new event will be omited even we don't have change in the store.
  if (certsUpdated) {
    return newCertificates;
  }

  return certificates;
}

function updateStatus(certificates: ICertificateData[], certReqId: string, status: CertStatus): ICertificateData[] {
  const newCertificates = JSON.parse(JSON.stringify(certificates));
  return newCertificates.map(cert => {
       if (cert.certReqId === certReqId) {
          cert.status = status;
          return cert;
        } else {
          return cert;
      }
   }
  );
}

function updateDevices(
    certificates: ICertificateData[],
    payload: {
      certReqId: ICertificateData['certReqId'],
      newDevices: IMobileDevice[]
    }): ICertificateData[] {

  const newCertificates: ICertificateData[] = JSON.parse(JSON.stringify(certificates));
  let certsUpdated = false;
  newCertificates.forEach(cert => {
     if (cert.certReqId === payload.certReqId) {
        certsUpdated = true;
        cert.deviceIds = payload.newDevices.map(device => device.appId);
      }
    });

  // We need this check because JSON.parse(JSON.stringify(certificates)) creates separate copy and this means
  // new event will be omited even we don't have change in the store.
  if (certsUpdated) {
    return newCertificates;
  }

  return certificates;
}
